import { Map1, NoteFavorite, Task } from 'iconsax-react';

export const navItems = [
  { name: 'Public Information', Icon: NoteFavorite },
  { name: 'Itinerary', Icon: Map1 },
  { name: 'Others', Icon: Task },
];
